export class Tremolo {
    constructor(ctx) {
        this.ctx = ctx;
        this.input = this.ctx.createGain();
        this.output = this.ctx.createGain();
        
        this.vca = this.ctx.createGain();
        this.lfo = this.ctx.createOscillator();
        this.lfoGain = this.ctx.createGain();
        
        // Routing
        // Input -> VCA -> Output
        this.input.connect(this.vca);
        this.vca.connect(this.output);
        
        // LFO -> VCA.gain
        this.lfo.connect(this.lfoGain);
        this.lfoGain.connect(this.vca.gain);
        
        // Setup
        this.lfo.type = 'sine';
        this.lfo.frequency.value = 5; // Hz
        this.lfo.start();
        
        this.vca.gain.value = 1.0; // Base gain
        this.lfoGain.gain.value = 0.0; // Depth (0 by default)
    }

    setup() {
        return Promise.resolve();
    }

    getInput() {
        return this.input;
    }

    getOutput() {
        return this.output;
    }

    setRate(value) {
        this.lfo.frequency.setTargetAtTime(value, this.ctx.currentTime, 0.02);
    }

    setDepth(value) {
        // Depth 0.0 to 1.0
        // We want the gain to oscillate around 1.0 (or somewhat below to avoid clipping)
        // Ideally: Gain = 1.0 - (LFO * Depth/2) - (Depth/2) ?
        // Simplest: VCA base = 1 - Depth/2. LFO ampl = Depth/2.
        // So Max = 1, Min = 1 - Depth.
        
        const depth = Math.max(0, Math.min(1, value));
        
        // When depth is 0, Base=1, LFO=0.
        // When depth is 1, Base=0.5, LFO=0.5 (Swing 0 to 1).
        
        const base = 1.0 - (depth * 0.5);
        this.vca.gain.setTargetAtTime(base, this.ctx.currentTime, 0.02);
        this.lfoGain.gain.setTargetAtTime(depth * 0.5, this.ctx.currentTime, 0.02);
    }

    setMix(value) {
        // Tremolo is usually insert, so mix controls depth essentially.
        // But for consistency with other modules, we can treat 'mix' as 'depth' if we want,
        // or actually implement Dry/Wet. 
        // Let's alias mix to depth for simplicity in the UI unless we want true parallel processing.
        this.setDepth(value);
    }
}
